import { createFileRoute } from "@tanstack/react-router";
import AMCAudienceDetails from "../../../../../../views/amc/audience/AMCAudienceDetails";

export const Route = createFileRoute("/_authenticated/user/amc/dashboard/audiences/$id")({
  component: AMCAudienceDetails,
  staticData: { application: "Advertising" },
});
